// extracted by mini-css-extract-plugin
export default {"text03":"text03--C0XCd","maxHoursError":"maxHoursError--T8IXK","stats":"stats--hjZkk","stat":"stat--wanC3"};